import { Check } from '@mui/icons-material'
import { Link, Typography } from '@mui/material'
import { PortableTextReactComponents } from '@portabletext/react'
import * as React from 'react'

export const blockSerializers: Partial<PortableTextReactComponents> = {
  types: {
    image: ({ value }) => <img src={value.imageUrl} />
  },
  marks: {
    link: ({ children, value }) => {
      const rel = !value.href.startsWith('/') ? 'noreferrer noopener' : undefined
      return (
        <Link href={value.href} rel={rel}>
          {children}
        </Link>
      )
    },
    strong: ({ children }) => {
      return <b>{children}</b>
    },
    italics: ({ children }) => {
      return <em>{children}</em>
    },
    underline: ({ children }) => {
      return <span style={{ textDecoration: 'underline' }}>{children}</span>
    },
    'strike-through': ({ children }) => {
      return <span style={{ textDecoration: 'strikethrough' }}>{children}</span>
    }
  },
  block: {
    h1: ({ children }) => (
      <Typography mt={5} variant="h1" component="h1" color="textPrimary">
        {children}
      </Typography>
    ),
    h2: ({ children }) => (
      <Typography mt={3} variant="h2" component="h2" color="textPrimary">
        {children}
      </Typography>
    ),
    h3: ({ children }) => (
      <Typography mt={10} variant="h3" component="h3" color="textPrimary">
        {children}
      </Typography>
    ),
    h4: ({ children }) => (
      <Typography mt={3} variant="h4" component="h4" color="textPrimary">
        {children}
      </Typography>
    ),
    h5: ({ children }) => (
      <Typography mt={3} variant="h5" component="h5" color="textPrimary">
        {children}
      </Typography>
    ),
    h6: ({ children }) => (
      <Typography mt={3} variant="h6" component="h6" color="textPrimary">
        {children}
      </Typography>
    ),
    blockquote: ({ children }) => (
      <Typography mt={2} variant="body2" component="blockquote" color="textPrimary">
        {children}
      </Typography>
    ),
    normal: ({ children }) => (
      <Typography mt={1.25} variant="body1" color="textPrimary">
        {children}
      </Typography>
    )
  },
  list: {
    bullet: ({ children }) => (
      <ul style={{ listStyleType: 'disc', paddingLeft: '1rem', margin: '1rem 0' }}>{children}</ul>
    ),
    number: ({ children }) => (
      <ol style={{ listStyleType: 'decimal', paddingLeft: '1rem', margin: '1rem 0' }}>
        {children}
      </ol>
    )
  },
  listItem: {
    bullet: ({ children }) => (
      <li style={{ marginTop: '1rem' }}>
        <Typography variant="body1" color="textPrimary">
          {children}
        </Typography>
      </li>
    ),
    number: ({ children }) => (
      <li style={{ marginTop: '1rem' }}>
        <Typography variant="body1" color="textPrimary">
          {children}
        </Typography>
      </li>
    ),
    checkmarks: ({ children }) => (
      <li style={{ marginTop: '1rem' }}>
        <Check /> {children}
      </li>
    )
  }
}
